import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import React from 'react';
import { SHARED_FILES_PARAM_DIRECTORIES, SHARED_FILES_PARAM_FILES, SharedFilesMoveForm } from '../SharedFiles.types';
import { useSharedFilesSelectedItemsContext } from '../context/SharedFilesSelectedItems';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { reloadCurrentLocation } from '../../../lib/window/Window';

type SharedFilesGlobalDownload = {
  headline: string;
  closeModal: () => void;
  form: SharedFilesMoveForm;
};

export function SharedFilesGlobalDeleteForm({ closeModal, headline, form }: SharedFilesGlobalDownload) {
  const { t } = useSonTranslation('SharedFiles');
  const { selectedFiles, selectedDirectories } = useSharedFilesSelectedItemsContext();

  return (
    <ModalDialog closeModal={closeModal} headline={headline} initialFocusIndex={1}>
      <AcceptDeclineForm
        form={form}
        headline={t('forms.globalDelete.headline')}
        messageSuccess={t('forms.globalDelete.success')}
        messageSending={t('forms.globalDelete.sending')}
        messageFail={t('forms.globalDelete.fail')}
        onSuccess={() => {
          // reload whole page es main menu items might disappear if sharedFilesDirectories are deleted
          // no useDelayed here as we dont want closing the modal to cancel this.
          setTimeout(reloadCurrentLocation, 2000);
        }}
      >
        {selectedFiles.map(file => (
          <input type="hidden" key={file} name={SHARED_FILES_PARAM_FILES} value={file} />
        ))}
        {selectedDirectories.map(dir => (
          <input type="hidden" key={dir} name={SHARED_FILES_PARAM_DIRECTORIES} value={dir} />
        ))}
      </AcceptDeclineForm>
    </ModalDialog>
  );
}
